<template>
    <ul class="Utility__list-inline">
        <slot :max-items="maxItems"></slot>

        <li class="Navbar__menu-item relative"
            v-if="hasMoreItems"
        >
            <a href="#" @click.prevent="showMore = ! showMore">More</a>

            <ul class="absolute bg-primary Utility__list-unstyled whitespace-no-wrap shadow" v-if="showMore">
                <li v-for="item in hiddenItems">
                    <a :href="item.url"
                       class="hover:bg-white hover:text-primary"
                    >
                        {{ item.text }}
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
    export default {
        data() {
            return {
                menuWidth: 0,
                itemWidths: [],
                hiddenItems: [],
                showMore: false,
            }
        },

        mounted() {
            /**
             * Adds an event listener for closing the calendar when something else is clicked on
             */
            document.addEventListener('click', e => {
                if (! this.$el.contains(e.target)) {
                    this.showMore = false;
                }
            });

            window.addEventListener('optimizedResize', () => {
                this.showMore = false;
                this.setMenuWidth();

                if (_.isEmpty(this.itemWidths) && window.innerWidth >= 992) {
                    this.setItemWidths();
                }

                if (window.innerWidth >= 992)  {
                    this.setHiddenItems();
                }
            });

            if (window.innerWidth >= 992) {
                this.setItemWidths();

                setTimeout(() => {
                    this.setMenuWidth();
                }, 100);

                setTimeout(() => {
                    this.setHiddenItems();
                }, 500);
            }
        },

        computed: {
            maxItems() {
                return parseInt(_.findLastKey(this.itemWidths, width => {
                    return width < this.menuWidth - 200;
                }));
            },

            hasMoreItems() {
                return this.maxItems < this.itemWidths.length - 1;
            },
        },

        methods: {
            setMenuWidth() {
                this.menuWidth = this.$el.offsetWidth;
            },

            setItemWidths() {
                let totalWidth = 0;

                _.forEach(this.$el.querySelectorAll('.Navbar__menu-item '), item => {
                    this.itemWidths.push(item.offsetWidth + totalWidth);
                    totalWidth = totalWidth + item.offsetWidth;
                });
            },

            setHiddenItems() {
                this.hiddenItems = _.map(this.$el.querySelectorAll('.Navbar__menu-item.hidden a'), item => {
                    return {
                        url: item.href,
                        text: item.innerHTML
                    };
                });
            }
        }
    }
</script>